<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("WITHDRAW.withdraw_request_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <!-- Start:: Settlement Information -->
        <div class="row">
          <div class="col-12 mb-3">
            <h5 class="section-title">{{ $t("WITHDRAW.settlement_info") }}</h5>
          </div>

          <!-- Start:: Settlement Amount -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('WITHDRAW.settlement_amount')"
            v-model.trim="data.amount"
            disabled
          />
          <!-- End:: Settlement Amount -->

          <!-- Start:: Orders Count -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('WITHDRAW.orders_total')"
            v-model.trim="data.orders_count"
            disabled
          />
          <!-- End:: Orders Count -->

          <!-- Start:: Provider Name -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          />
          <!-- End:: Provider Name -->
        </div>
        <!-- End:: Settlement Information -->

        <!-- Start:: Related Orders Table -->
        <div class="row mt-4" v-if="data.orders && data.orders.length > 0">
          <div class="col-12 mb-3">
            <h5 class="section-title">{{ $t("WITHDRAW.related_orders") }}</h5>
          </div>

          <div class="col-12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">{{ $t("PLACEHOLDERS.order_number") }}</th>
                    <th class="text-center">{{ $t("PLACEHOLDERS.order_status") }}</th>
                    <th class="text-center">{{ $t("FINANCIAL_REPORTS.commission") }}</th>
                    <th class="text-center">{{ $t("FINANCIAL_REPORTS.provider_amount") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in data.orders" :key="order.id">
                    <td class="text-center">{{ order.id }}</td>
                    <td class="text-center">{{ order.status }}</td>
                    <td class="text-center">{{ order.commission }}</td>
                    <td class="text-center">{{ order.provider_amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
        <!-- End:: Related Orders Table -->

      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Reject Modal -->
    <v-dialog v-model="rejectModal" max-width="500px">
      <v-card>
        <v-card-title>{{ $t("TITLES.reject_request") }}</v-card-title>
        <v-card-text>
          <base-input
            col="12"
            rows="4"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.reason_reject')"
            v-model.trim="rejectReason"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="rejectRequest"
            :disabled="!rejectReason || rejectReason.length < 3 || isProcessing"
          >
            {{ $t("BUTTONS.reject") }}
          </v-btn>
          <v-btn @click="rejectModal = false">{{ $t("BUTTONS.cancel") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Reject Modal -->
  </div>
</template>

<script>
export default {
  name: "WithdrawRequestShow",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      isProcessing: false,
      // End:: Loader Control Data

      // Start:: Data Collection
      data: {
        id: null,
        provider_name: null,
        amount: null,
        orders_count: null,
        status: null,
        orders: [],
      },
      // End:: Data Collection

      // Start:: Reject Modal
      rejectModal: false,
      rejectReason: "",
      // End:: Reject Modal
    };
  },

  methods: {
    // Start:: Get Data
    async getData() {
      this.isWaitingRequest = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `withdraw-requests/${this.$route.params.id}`,
        });
        this.isWaitingRequest = false;

        if (res.data && res.data.data) {
          this.data = res.data.data;
        }
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error.response?.data?.message || error.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Get Data

    // Start:: Accept Request
    async acceptRequest() {
      this.isProcessing = true;
      try {
        await this.$axios({
          method: "POST",
          url: `withdraw-requests/${this.data.id}/accept`,
        });
        this.isProcessing = false;
        this.$message.success(this.$t("MESSAGES.acceptedSuccessfully"));
        this.$router.push("/withdraw/all");
      } catch (error) {
        this.isProcessing = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Accept Request

    // Start:: Reject Request
    async rejectRequest() {
      this.isProcessing = true;
      try {
        await this.$axios({
          method: "POST",
          url: `withdraw-requests/${this.data.id}/reject`,
          data: {
            rejection_reason: this.rejectReason,
          },
        });
        this.isProcessing = false;
        this.rejectModal = false;
        this.$message.success(this.$t("MESSAGES.rejectedSuccessfully"));
        this.$router.push("/withdraw/all");
      } catch (error) {
        this.isProcessing = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Reject Request
  },

  created() {
    this.getData();
  },
};
</script>

<style scoped>
.section-title {
  color: var(--main_theme_clr);
  font-weight: bold;
  border-bottom: 2px solid var(--main_theme_clr);
  padding-bottom: 10px;
}

.gap-3 {
  gap: 1rem;
}
</style>
